import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        getArtifactsCount: builder.query<GetArtifactsCountResponse, GetArtifactsCountRequest>({
            query: (request: GetArtifactsCountRequest) => ({
                url: "getArtifactsCount",
                body: request,
                method: "POST",
            }),
        }),
        getAggregateMailCardInfoByUser: builder.query<
            GetArtifactsCountResponse,
            GetArtifactsCountRequest
        >({
            query: (request?: GetArtifactsCountRequest) => ({
                url: "getArtifactsCount",
                body: request,
                method: "POST",
            }),
        }),
        getCalendarInfo: builder.query<GetArtifactsCountResponse, GetArtifactsCountRequest>({
            query: (request?: GetArtifactsCountRequest) => ({
                url: "getArtifactsCount",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useLazyGetAggregateMailCardInfoByUserQuery, useLazyGetCalendarInfoQuery } =
    extendedApi;

export interface GetArtifactsCountRequest {
    useCase: "GET_AGGREGATED_DOCUMENTS" | "GET_AGGREGATED_DOCUMENTS_BY_DUE_DATE";
    businessUseCase: string;
    queryParams: {
        startDate?: string;
        endDate?: string;
        assignedTo?: string;
    };
}

export interface GetArtifactsCountResponse {
    artifactCountMap: any;
}
